import { Injectable } from "@angular/core";
import { HttpClient, HttpBackend } from "@angular/common/http";
import { filter, map, tap } from "rxjs";

export type MsalConfig = {
  auth: {
    clientId: string;
    tenant: string;
    policy: string;
    authority: string;
  };
};

export enum KnownConfigKey {
  gatewayUrl = "gatewayUrl",
  spatialMapUrl = "spatialMapUrl",
  spatialFileUploadLocation = "spatialFileUploadLocation",
  msalConfig = "msalConfig",
  interceptor = "interceptor",
  enableOffsetPayments = "enableOffsetPayments",
  enableCreditOffers = "enableCreditOffers",
  maintenanceMode = "maintenanceMode",
  maintenanceMessage = "maintenanceMessage",
  maintenanceRetryMessage = "maintenanceRetryMessage"
}

export type Config = {
  gatewayUrl: string;
  spatialMapUrl: string;
  spatialFileUploadLocation: string;
  msalConfig: MsalConfig;
  interceptor: InterceptorConfig;
  enableOffsetPayments: boolean;
  enableCreditOffers: boolean;
  maintenanceMode: boolean;
  maintenanceMessage: string;
  maintenanceRetryMessage: string;
};

export type InterceptorConfig = {
  interactionType: string;
  protectedResourceMap: Iterable<readonly [string, string[]]>;
};

const mapToMsalConfig = (sourceConfig) => {
  const {
    apiEndpointBaseUrl,
    msalConfig,
    interceptor,
    interceptor: { protectedResourceMap: resourceMap },
    spatialFileUploadLocation,
    spatialMapUrl,
    enableOffsetPayments,
    enableCreditOffers,
    maintenanceMode,
    maintenanceMessage,
    maintenanceRetryMessage
  } = sourceConfig as any;

  const protectedResourceMap = resourceMap.map((config) =>
    config.flatMap(({ actions, endpoint }) => [endpoint, actions])
  );

  return {
    gatewayUrl: apiEndpointBaseUrl,
    spatialMapUrl: spatialMapUrl,
    spatialFileUploadLocation: spatialFileUploadLocation,
    msalConfig,
    interceptor: { ...interceptor, protectedResourceMap },
    enableOffsetPayments:enableOffsetPayments,
    enableCreditOffers,
    maintenanceMode,
    maintenanceMessage,
    maintenanceRetryMessage
  };
};

@Injectable({
  providedIn: "root",
})
export class AppConfigService {
  private settings: any;
  private http: HttpClient;
  constructor(httpHandler: HttpBackend) {
    this.http = new HttpClient(httpHandler);
  }

  initialize(endpoint: string): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      this.http
        .get(endpoint)
        .pipe(
          filter((v) => !!v),
          map(mapToMsalConfig)
        )
        .subscribe({
          next: (value) => {
            this.settings = value;
            resolve(true);
          },
          error: (msg) => {
            //reject(msg),
            console.error('AppConfigService initialization error:', msg);
            resolve(false);
          }
        });
    });
  }

  getSetting<T>(key?: string | KnownConfigKey): T | undefined {
    //console.log(this.settings);
    if (!key) {
      return this.settings;
    }

    return key in this.settings ? this.settings[key] : undefined;
  }
}
